import * as React from "react"
import {useMemo} from "react"
import {CssBaseline, GlobalStyles as MUIGlobalStyles} from '@mui/material';
import {createTheme, StyledEngineProvider, ThemeProvider as MUIThemeProvider} from '@mui/material/styles';
import {mergeDicts} from "@ui-seeker/utils"

import {THEME_MODE} from "../../@constants";
import {GlobalStyles} from "./globalStyles";
import {minimalPaletteLight, minimalPalleteDark} from "./palette";
import minimalTypography from "./typography";
import {buildShadows} from "./shadows";
import buildCustomShadows from "./customShadows";
import overrideComponents from "./overrides";



export default function MinimalThemeProvider({ global={}, palette={}, shape={}, typography={}, overrides=()=>({}), children }) {
    const minimalPalette = palette.mode === THEME_MODE.DARK ? minimalPalleteDark : minimalPaletteLight

    const themeOptions = useMemo(() => {
        const themePalette = mergeDicts(minimalPalette, palette)
        const themeTypography = mergeDicts(minimalTypography, typography)

        return {
            palette: themePalette,
            shape: { borderRadius: 6, ...shape },
            typography: themeTypography,
            shadows: buildShadows(themePalette),
            customShadows: buildCustomShadows(themePalette),
        }
    }, [])
    const theme = createTheme(themeOptions)
    theme.components = mergeDicts(overrideComponents(theme), overrides(theme))

    return <StyledEngineProvider injectFirst>
        <MUIThemeProvider theme={theme}>
            <CssBaseline />
            <MUIGlobalStyles styles={mergeDicts(GlobalStyles(theme.palette), global)} />
            {children}
        </MUIThemeProvider>
    </StyledEngineProvider>
}